export default __webpack_public_path__ + "static/services-page-image-8143138a8b1b7a7cef27b409c7df920b.jpg";